import axios from 'axios';
import { AppConfig } from 'AppConfig';
import LocalStore from 'utils/LocalStore';

export const trackingTypes = {
  APPLICATION: 'APPLICATION',
  REPORT: 'REPORT',
  TENANT: 'TENANT',
  USER: 'USER',
  SEARCH: 'SEARCH'
};

export const trackingActions = {
  READ: 'READ',
  SWITCH: 'SWITCH',
  UPDATE: 'UPDATE',
  CLICK: 'CLICK',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  QUERY: 'QUERY'
};

export const trackClick = async function (type, action, target, detail) {
  // Retrieve jsessionId from LocalStorage
  var jsessionId = LocalStore.getJsessionId();

  if (!jsessionId) {
    jsessionId = 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[x]/g, () => 
      ((Math.random() * 16) | 0).toString(16).toUpperCase()); // Generate a new jsessionId if not found
    LocalStore.saveJsessionId(jsessionId); // Use the new saveJsessionId method
  }
  
  axios
    .post(AppConfig.FO_INITIAL_URL + '/click/track', {
      type,
      action,
      target,
      detail: detail || null,
      sessionId: jsessionId // Use jsessionId from LocalStorage
    })
    .catch((error) => {
      console.error('click call issue:', error);
    });
};